import { render, staticRenderFns } from "./PrintMarksDialog.vue?vue&type=template&id=0dddb176"
import script from "./PrintMarksDialog.vue?vue&type=script&lang=js"
export * from "./PrintMarksDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports